import React from "react";
import { ShieldCheck, Lock, EyeOff } from "lucide-react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { Reveal } from "@/components/common/Reveal";
import { CONFIDENTIALITY } from "@/content/homeContent";

const icons = [Lock, EyeOff, ShieldCheck];

export const Confidentiality = () => {
  return (
    <Section id="confidentiality-section" tone="dark">
      <Reveal>
        <SectionHeading
          microLabel={CONFIDENTIALITY.microLabel}
          title={CONFIDENTIALITY.title}
          description={CONFIDENTIALITY.description}
        />
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        {CONFIDENTIALITY.points.map((p, i) => {
          const Icon = icons[i % icons.length];
          return (
            <Reveal key={p.title} delay={i * 0.06}>
              <div
                data-testid={`confidentiality-point-${i}`}
                className="h-full rounded-2xl border border-white/10 bg-white/[0.03] p-7"
              >
                <span className="grid h-11 w-11 place-items-center rounded-xl border border-white/10 bg-white/[0.04] text-strato-blue">
                  <Icon className="h-5 w-5" strokeWidth={1.5} />
                </span>
                <h3 className="mt-6 font-display text-lg font-medium text-white">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-[1.6] text-white/60">
                  {p.description}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};
